import { render, staticRenderFns } from "./LK.vue?vue&type=template&id=0f1d8524&"
import script from "./LK.vue?vue&type=script&lang=js&"
export * from "./LK.vue?vue&type=script&lang=js&"
import style0 from "./LK.vue?vue&type=style&index=0&id=0f1d8524&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports